import {atom} from "recoil";
import {IUploadingFileGroup} from "@/widgets/file-uploader-widget/interface";

export const fileUploaderConnectionIdState = atom<string>({
    default: '',
    key: 'fileUploaderConnectionIdState'
});

export const uploadingFilesState = atom<IUploadingFileGroup[]>({
    default: [],
    key: 'uploadingFilesState'
});

export const openFileUploaderList = atom<boolean>({
    default: false,
    key: 'openFileUploaderList'
});

export const pinFileUploaderState = atom<boolean>({
    default: false,
    key: 'pinFileUploaderState'
});

/** SKU to attach on set-order-item-file-status when upload started from Customer SKU. */
export const fileUploaderTargetSkuState = atom<string | null>({
    default: null,
    key: 'fileUploaderTargetSkuState',
});

/** When true, file-uploader polling (UpdateFileUploader / updateFileStatus) is active. */
export const fileUploaderSessionActiveState = atom<boolean>({
    default: false,
    key: 'fileUploaderSessionActiveState',
});